/**
* Intended to be passed to an async function in order to cancel the operation
*/
export class PromiseCancellationToken {

    private promise: Promise<string>;
    private cancelPromise: () => void;

    constructor(
    ) {
        this.reset();
    }

    public cancel() {
        this.cancelPromise();
    }

    public onCancel(onfulfilled: (() => any)): Promise<any> {
        return this.promise.then(onfulfilled);
    }

    public reset() {
        this.promise = new Promise<string>(resolve => {
            this.cancelPromise = resolve;
        });
    }
}
